import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

// api.defaults.headers.get = {
// 	...api.defaults.headers.get,
// 	"Cache-Control": "no-cache, no-store, must-revalidate",
// 	Pragma: "no-cache",
// 	Expires: "0",
// };

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
});

export default api;
